<template>
  <div id="DataOutflow">
    Drag this marker to see where commuters {{ flowNames[flowDirection].name }}.
    <div v-if="outRegionData !== null">
      {{ format(outRegionData) }} commuters {{ flowNames[flowDirection].name }} outside the region.
    </div>
  </div>
</template>

<script>
import {queryFeatures} from '@esri/arcgis-rest-feature-service'
import * as d3 from "d3";

export default {
  name: "DataOutflow",
  props: ['flow_tract_selected', 'flowDirection', 'flowSelect', 'flowNames'],
  data: function () {
    return {
      outRegionData: null,
    }
  },
  computed: {
    outRegionflowRequestOptions: function () {
      let outRegion = `workplace = 'OutRegion'`
      let tract = `res_tract = ${this.flow_tract_selected}`
      if (this.flowDirection === "Inflow") {
        outRegion = `residence = 'OutRegion'`
        tract = `wrktract = ${this.flow_tract_selected}`
      }
      let codes = `and flow_naics_code IN (${this.flowSelect.map(i => i.statevalue).join(',')})`;
      if (this.flowSelect.length === 0) {
        codes = `and flow_naics_code = 99`;
      }
      return {
        url: 'https://services1.arcgis.com/xUx8EjNc6egUPYWh/arcgis/rest/services/all_flows_to_region_tracts_by_industry_2016/FeatureServer/0',
        where: `${outRegion} and ${tract} ${codes}`,
        outStatistics: [
          {
            onStatisticField: 'flowworkers16plus',
            statisticType: 'sum',
            outStatisticFieldName: 'flowworkers16plus',
          }],
        f: "json",
        outFields: ['flowworkers16plus']
      }
    },
  },
  methods: {
    format: d3.format(',d'),
  },
  watch: {
    outRegionflowRequestOptions:
        {
          immediate: true,
          handler: function () {
            this.outRegionData = null
            if (this.flow_tract_selected && this.flow_tract_selected > 0) {
              queryFeatures(this.outRegionflowRequestOptions).then((res) => {
                this.outRegionData = res.features[0].attributes['flowworkers16plus']
              })
            }
          }
        },
  }
}
</script>

<style scoped>
</style>
